import { CampaignDetail, CampaignList } from 'types/campaign';
import { ContactCampaignFilter, SmartList } from 'types/contact';
import axiosServices from 'utils/axios';

export async function getCampaignsList(
  companyId: string,
  filter: ContactCampaignFilter,
  contactId?: string,
  excludecampaignId?: string
): Promise<CampaignList[]> {
  try {
    if (!companyId) {
      throw new Error('Company ID is required to fetch campaigns');
    }

    // Build the query string dynamically based on provided filters
    let queryParams = `/api/company-campaign/${companyId}/select?`;

    if (filter.status) {
      queryParams += `status=${encodeURIComponent(filter.status)}&`;
    }

    if (filter.target) {
      queryParams += `target=${encodeURIComponent(filter.target)}&`;
    }

    if (contactId) {
      queryParams += `excludedContactId=${encodeURIComponent(contactId)}&`;
    }

    if (excludecampaignId && excludecampaignId !== 'new') {
      queryParams += `excludedCampaignId=${encodeURIComponent(excludecampaignId)}&`;
    }

    // Remove the trailing '&' or '?' at the end of the queryParams string
    queryParams = queryParams.slice(0, -1);

    // Perform the API request
    const response = await axiosServices.get(queryParams);
    const data = response.data;
    return data;
  } catch (error) {
    console.error('There was an error fetching campaigns:', error);
    throw error;
  }
}

export async function joinCampaign(
  campaignManagerId: string,
  contactIds: string[],
  bulk: boolean = false,
  all: boolean = false,
  currentSmartFilter?: SmartList[],
  isPartners?: boolean,
  search?: string
): Promise<any> {
  try {
    let url = `/api/company-campaign/join`;

    if (contactIds.length > 1 || bulk) {
      url = `/api/company-campaign/join/bulk`;
    }

    const response = await axiosServices.post(url, {
      campaignManagerId,
      contactIds,
      all,
      currentSmartFilter,
      isPartners,
      search
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.error('There was an error creating contact:', error);
    throw error;
  }
}

export async function exitCampaign(
  campaignManagerId: string,
  contactIds: string[],
  bulk: boolean = false,
  all: boolean = false,
  currentSmartFilter?: SmartList[],
  isPartners?: boolean,
  search?: string
): Promise<any> {
  try {
    let url = `/api/company-campaign/exit`;

    if (contactIds.length > 1 || bulk) {
      url = `/api/company-campaign/exit/bulk`;
    }

    const response = await axiosServices.post(url, {
      campaignManagerId,
      contactIds,
      all,
      currentSmartFilter,
      isPartners,
      search
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.error('There was an error creating contact:', error);
    throw error;
  }
}

export async function getCampaignDetail(campaignManagerId: string, contactId: string): Promise<CampaignDetail> {
  try {
    const response = await axiosServices.get(`/api/company-campaign/${campaignManagerId}/contact/${contactId}`);
    const data = response.data;
    return data;
  } catch (error) {
    console.error('There was an error creating contact:', error);
    throw error;
  }
}
